import React from 'react';
import { Label } from 'semantic-ui-react'

import ClaimsApprovedLabelImage from './claims_approved_label.png';
import ClaimsDefaultLabelImage from './claims_default_label.png';
import ClaimsRejectedLabelImage from './claims_rejected_label.png';

const ClaimStatusLabel = (props) => {
    const retrieveStatusImage = (status) => {
        switch(status) {
            case 'Approved':
                return ClaimsApprovedLabelImage;
            case 'Rejected':
                return ClaimsRejectedLabelImage;
            default:
                return ClaimsDefaultLabelImage;
        }
    }
    return (
        <Label image>
            <img src={retrieveStatusImage(props.status)} />
            {props.status}
        </Label>
    );
}

export default ClaimStatusLabel;